import React from "react";
import { Link, useLocation } from "react-router-dom";
import { ButtonBase } from "@mui/material";
import { Button, TextField, Container, Grid } from "@mui/material";
import adaptabiltyIcon from "../assets/Navigation/nav_icon_adaptability_white.png";
import adaptabiltyIconActive from "../assets/Navigation/nav_icon_adaptability_green.png";
import expertiseIcon from "../assets/Navigation/nav_icon_expertise_white.png";
import expertiseIconActive from "../assets/Navigation/nav_icon_expertise_green.png";
import costIcon from "../assets/Navigation/nav_icon_cost_white.png";
import costIconActive from "../assets/Navigation/nav_icon_cost_green.png";
import dataIcon from "../assets/Navigation/nav_icon_quality_white.png";
import dataIconActive from "../assets/Navigation/nav_icon_quality_green.png";
import { selectAdaptabilityComplete } from "../features/adaptability/adaptabilitySlice";
import { selectDataComplete } from "../features/data/dataSlice";
import { selectCostComplete } from "../features/cost/costSlice";
import { selectExpertiseComplete } from "../features/expertise/expertiseSlice";
import { useSelector } from "react-redux";
import complete from "../assets/Navigation/nav_finished_section.png";

const SubHeaderNav = (props) => {
  let currentPath = useLocation().pathname;
  let adaptabilityComplete = useSelector(selectAdaptabilityComplete);
  let dataComplete = useSelector(selectDataComplete);
  let expertiseComplete = useSelector(selectExpertiseComplete);
  let costComplete = useSelector(selectCostComplete);

  return (
    <Container maxWidth='lg' className='subheader_nav_container'>
        <div className='subheader_nav_group'>
          <ButtonBase className='subheader_nav' component={Link} to={"/adaptability"}>
            {currentPath === "/adaptability" ? <img className='side_nav_icon' src={adaptabiltyIconActive} /> : <img className='side_nav_icon' src={adaptabilityComplete ? complete : adaptabiltyIcon} />}
          </ButtonBase>
          <ButtonBase className='subheader_nav' component={Link} to={"/data"}>
            {currentPath === "/data" ? <img className='side_nav_icon' src={dataIconActive} /> : <img className='side_nav_icon' src={dataComplete ? complete : dataIcon} />}
          </ButtonBase>
          <ButtonBase className='subheader_nav' component={Link} to={"/expertise"}>
            {currentPath === "/expertise" ? <img className='side_nav_icon' src={expertiseIconActive} /> : <img className='side_nav_icon' src={expertiseComplete ? complete : expertiseIcon} />}
          </ButtonBase>
          <ButtonBase className='subheader_nav' component={Link} to={"/cost"}>
            {currentPath === "/cost" ? <img className='side_nav_icon' src={costIconActive} /> : <img className='side_nav_icon' src={costComplete ? complete : costIcon} />}
          </ButtonBase>
        </div>
        <div className='forward_buttonContainer'>
          <Button component={Link} to='/results' className='forward_button'>
            Results
          </Button>
        </div>
    </Container>
  );
};

export default SubHeaderNav;
